module.exports = __webpack_public_path__ + "img/nav-icon2.57b15ad0.svg";